import { Budget } from '@/components/pages/edit-campaign/form-elements/budget';
import { Conversion } from '@/components/pages/edit-campaign/form-elements/conversion';
import { Cpa } from '@/components/pages/edit-campaign/form-elements/cpa';
import { Dates } from '@/components/pages/edit-campaign/form-elements/dates';
import { TargetBudget } from '@/components/pages/edit-campaign/target-budget';
import { useEditCampaignContext } from '@/contexts/edit-campaign-context';

export function DefaultForm() {
  const { campaign } = useEditCampaignContext();

  return (
    <>
      <Dates campaignStartsAt={campaign?.starts_at} />
      <Budget />
      <TargetBudget
        budgetSpent={campaign?.budget_spent ?? 0}
        hideTargetBudget={campaign?.status === 'completed'}
      />
      <Cpa />
      <Conversion />
    </>
  );
}
